import { Helmet } from 'react-helmet-async';
import { useTheme } from '@/theme/ThemeProvider';
import { AppVersion } from '@/components/AppVersion';
import styles from './IntroPage.module.css';

type IntroPageProps = {
  onLogin: () => Promise<void> | void;
  isLoading?: boolean;
};

const IntroPage = ({ onLogin, isLoading = false }: IntroPageProps) => {
  const { theme } = useTheme();

  return (
    <div className={styles.page}>
      <Helmet>
        <title>Welcome • AwkHerd</title>
      </Helmet>
      <div className={styles.card}>
        <header className={styles.header}>
          <div className={styles.logoFrame}>
            <img
              className={styles.logo}
              src={theme.assets.logo}
              alt="AwkHerd logo"
              width={64}
              height={64}
            />
          </div>
          <div>
            <span className={styles.overline}>AwkHerd</span>
            <h1>Social Connector</h1>
            <p className={styles.subtitle}>Sign in to explore connections around you.</p>
          </div>
        </header>
        <p className={styles.lead}>
          Discover nearby connections, chat with your herd, and share interests and vibes.
          Sign in to get started.
        </p>
        <button
          type="button"
          className={styles.loginButton}
          onClick={() => {
            Promise.resolve(onLogin()).catch((error) => {
              console.warn('Login request failed', error);
            });
          }}
          disabled={isLoading}
        >
          {isLoading ? 'Preparing sign-in…' : 'Sign in with AwkHerd'}
        </button>
        <AppVersion className={styles.version} />
      </div>
    </div>
  );
};

export default IntroPage;
